<ng-container *ngFor="let bound of bounds; index as boundIndex">
  <div class="l-section u-mt-pc-40 u-mt-tb-40 u-mt-sp-40">
    <div class="p-flight-bound">
      <div class="p-flight-bound__heading">
        <div class="p-flight-bound__heading-title">
          <h2 class="c-bound-title01">{{ 'label.number.section.n' | staticMsg : { '0': boundIndex + 1 } }}</h2>
        </div>
      </div>
      <!-- 出発地点to到着地点、中継地点、出発日時表示 start -->
      <div class="p-flight-bound__bound02">
        <span class="p-flight-bound__fromto">
          <span class="p-flight-bound__fromto-from">{{ originLocationNameList[boundIndex] }}</span>
          <span class="p-flight-bound__fromto-separator">{{ 'label.section' | staticMsg }}</span>
          <span class="p-flight-bound__fromto-to">{{ destinationLocationNameList[boundIndex] }}</span>
        </span>
      </div>
      <div class="p-flight-bound__via" *ngIf="connectionLocationNameList[boundIndex]">
        {{ 'label.oneStopFlightLocation' | staticMsg : { '0': connectionLocationNameList[boundIndex] } }}
      </div>
      <div
        class="p-flight-bound__bound03"
        [innerHTML]="requestMock?.itineraries?.[boundIndex]?.departureDate ?? '' | dateFormat : 'default_departuredate'"
      ></div>
      <!-- 出発地点to到着地点、中継地点、出発日時表示 end -->
    </div>
    <!-- 旅程表示 start -->
    <div class="p-flight-container" [ngClass]="{ 'p-flight-container--applied': fareFamily?.isPromotionApplied }">
      <div class="p-flight-container__inner">
        <div class="p-flight-container__inner-item1">
          <!-- 遅延、早発表示 start-->
          <div class="p-flight-container__announce">
            <div class="p-flight-container__announce-item">
              <span class="c-tag c-tag--type01" *ngIf="bound.isContainedDelayedFlight"
                ><strong>{{ 'm_static_message-label.delayed' | staticMsg }}</strong></span
              >
              <span class="c-tag c-tag--type01" *ngIf="bound.isContainedEarlyDepartureFlight"
                ><strong>{{ 'm_static_message-label.earlyDeparture' | staticMsg }}</strong></span
              >
            </div>
          </div>
          <!-- 遅延、早発表示 end-->
          <!-- 時間変更（遅延、早発）の場合はclass追加 -->
          <div
            class="p-flight-container__plan"
            [ngClass]="{ 'p-flight-container__plan-government': isPc && bound.isContainedSubjectToGovernmentApproval }"
          >
            <div
              class="c-flight-plan"
              [ngClass]="{
                'c-flight-plan--change': this.flightPlanChange(bound)
              }"
            >
              <!-- 出発地点名 -->
              <p class="c-flight-plan__location c-flight-plan__item-1" *ngIf="isLocationDisplayList[boundIndex]">
                <em
                  [ngClass]="{
                    'c-flight-plan__location-em': isMultiAirPortOriginLocationList[boundIndex],
                    'c-flight-plan__location': !isMultiAirPortOriginLocationList[boundIndex]
                  }"
                  *ngIf="isOriginLocationList[boundIndex]"
                  >{{ originLocationAirPortNameList[boundIndex] }}</em
                >
                <em
                  [ngClass]="{
                    'c-flight-plan__location-em': isMultiAirPortOriginLocationList[boundIndex],
                    'c-flight-plan__location': !isMultiAirPortOriginLocationList[boundIndex]
                  }"
                  *ngIf="!isOriginLocationList[boundIndex]"
                  >{{ bound.originLocationName }}</em
                >
              </p>
              <div class="c-flight-plan__time c-flight-plan__item-2">
                <!-- 時間変更有無で出し分け（出発時刻） start -->
                <!-- 時間変更あり start-->
                <ng-container *ngIf="bound.originDepartureEstimatedDateTime !== undefined; else notDepartureEstimated">
                  <!-- 変更前の時間設定 start-->
                  <div
                    class="c-flight-plan__time-box"
                    [innerHTML]="
                      bound.originDepartureDateTime ?? ''
                        | dateFormat : 'availability.flightPlan_departuredate.time.old' : true
                    "
                  ></div>
                  <!-- 変更前の時間設定 end-->
                  <!-- 変更後の時間設定 start -->
                  <ng-container *ngIf="isDepartureDateCheckList[boundIndex]; else notDepartureDateCheckList">
                    <div
                      class="c-flight-plan__time-box"
                      style="color: #d91829"
                      [innerHTML]="
                        bound.originDepartureEstimatedDateTime
                          | dateFormat : 'availability.flightPlan_departuredate.time.latest'
                      "
                    ></div>
                  </ng-container>
                  <ng-template #notDepartureDateCheckList>
                    <div class="c-flight-plan__time-box">
                      <span
                        style="color: #d91829"
                        [innerHTML]="
                          bound.originDepartureEstimatedDateTime
                            | dateFormat : 'flightPlan_departureArrivalDate.dateTime'
                        "
                      ></span>
                    </div>
                  </ng-template>
                  <div class="c-flight-plan__time-box">
                    <!-- 深夜表記部分 start -->
                    <span
                      class="c-flight-plan__time-text"
                      *ngIf="bound.flights?.[0]?.isLateNightDeparture && (lang === 'ja' || lang === 'cn' || lang === 'ko')"
                      [innerHTML]="
                        bound.originDepartureEstimatedDateTime
                          | dateFormat : 'default_departuredate.midnightTime' : true
                      "
                    >
                    </span>
                    <!-- 深夜表記部分 end -->
                  </div>
                  <!-- 変更後の時間設定 end -->
                </ng-container>
                <!-- 時間変更あり end-->

                <!-- 時間変更なし start-->
                <ng-template #notDepartureEstimated>
                  <div
                    class="c-flight-plan__time-box"
                    [innerHTML]="
                      bound.originDepartureDateTime ?? '' | dateFormat : 'availability.flightPlan_departuredate.time'
                    "
                  ></div>
                  <!-- 深夜表記部分 start -->
                  <div class="c-flight-plan__time-box">
                    <span
                      class="custom-late-night-departure"
                      *ngIf="bound.flights?.[0]?.isLateNightDeparture && (this.lang === 'ja' || this.lang === 'cn' || this.lang === 'ko')"
                      >{{
                        bound.originDepartureDateTime ?? '' | dateFormat : 'default_departuredate.midnightTime' : true
                      }}
                    </span>
                  </div>
                  <!-- 深夜表記部分 end -->
                </ng-template>
                <!-- 時間変更なし end-->
                <!-- 時間変更有無で出し分け（出発時刻） end -->
              </div>
              <div class="c-flight-plan__period c-flight-plan__period--0stop c-flight-plan__item-3">
                <p class="c-flight-plan__period-layover" *ngIf="bound.numberOfConnections === 0; else connection">
                  {{ 'm_static_message-label.directFlight' | staticMsg }}
                </p>
                <ng-template #connection>
                  <p class="c-flight-plan__period-layover">
                    {{ 'm_static_message-label.connectionCount' | staticMsg : { '0': bound.numberOfConnections } }}
                  </p>
                </ng-template>
                <p class="c-flight-plan__period-time" *ngIf="durationList[boundIndex] !== ''">
                  {{ durationList[boundIndex] | dateFormat : 'default_flightTotalTime' }}
                </p>
              </div>
              <!-- 到着地点名 -->
              <p class="c-flight-plan__location c-flight-plan__item-4" *ngIf="isLocationDisplayList[boundIndex]">
                <em
                  [ngClass]="{
                    'c-flight-plan__location-em': isMultiAirPortDestinationLocationList[boundIndex],
                    'c-flight-plan__location': !isMultiAirPortDestinationLocationList[boundIndex]
                  }"
                  *ngIf="isDestinationLocationList[boundIndex]"
                  >{{ destinationLocationAirPortNameList[boundIndex] }}</em
                >
                <em
                  [ngClass]="{
                    'c-flight-plan__location-em': isMultiAirPortDestinationLocationList[boundIndex],
                    'c-flight-plan__location': !isMultiAirPortDestinationLocationList[boundIndex]
                  }"
                  *ngIf="!isDestinationLocationList[boundIndex]"
                  >{{ bound.destinationLocationName }}</em
                >
              </p>
              <div class="c-flight-plan__time c-flight-plan__item-5">
                <!-- 時間変更有無で出し分け（到着時刻） start -->
                <!-- 時間変更あり start-->
                <ng-container *ngIf="bound.destinationArrivalEstimatedDateTime !== undefined; else notArrivalEstimated">
                  <!-- 変更前の時間設定 start-->
                  <div
                    class="c-flight-plan__time-box"
                    [innerHTML]="
                      bound.destinationArrivalDateTime ?? ''
                        | dateFormat : 'availability.flightPlan_departuredate.time.old'
                    "
                  ></div>
                  <!-- 変更前の時間設定 end-->
                  <!-- 変更後の時間設定 start-->
                  <ng-container *ngIf="isArrivalDateCheckList[boundIndex]; else notArrivalDateCheckList">
                    <div
                      class="c-flight-plan__time-box"
                      style="color: #d91829"
                      [innerHTML]="
                        bound.destinationArrivalEstimatedDateTime
                          | dateFormat : 'availability.flightPlan_departuredate.time.latest'
                      "
                    ></div>
                  </ng-container>
                  <ng-template #notArrivalDateCheckList>
                    <div class="c-flight-plan__time-box">
                      <span
                        style="color: #d91829"
                        [innerHTML]="
                          bound.destinationArrivalEstimatedDateTime
                            | dateFormat : 'flightPlan_departureArrivalDate.dateTime'
                        "
                      ></span>
                    </div>
                  </ng-template>
                  <!-- 到着日時差 start-->
                  <ng-container
                    *ngIf="
                      bound.destinationArrivalEstimatedDaysDifference || bound.destinationArrivalDaysDifference === -1;
                      else changeTimeNotBold
                    "
                  >
                    <div
                      class="c-flight-plan__time-box"
                      *ngIf="bound.destinationArrivalEstimatedDaysDifference || bound.destinationArrivalDaysDifference"
                    >
                      <span class="c-flight-plan__time-text" style="color: #d91829; font-weight: bold">{{
                        stringArrivalDaysDifference?.[boundIndex] ?? '' | staticMsg
                      }}</span>
                    </div>
                  </ng-container>
                  <ng-template #changeTimeNotBold>
                    <div
                      class="c-flight-plan__time-box"
                      *ngIf="bound.destinationArrivalEstimatedDaysDifference || bound.destinationArrivalDaysDifference"
                    >
                      <span class="c-flight-plan__time-text" style="color: #d91829">{{
                        stringArrivalDaysDifference?.[boundIndex] ?? '' | staticMsg
                      }}</span>
                    </div>
                  </ng-template>
                  <!-- 到着日時差 end-->
                  <!-- 変更後の時間設定 end-->
                  <!-- 時間変更なし start-->
                </ng-container>
                <ng-template #notArrivalEstimated>
                  <div
                    class="c-flight-plan__time-box"
                    [innerHTML]="
                      bound.destinationArrivalDateTime ?? '' | dateFormat : 'availability.flightPlan_departuredate.time'
                    "
                  ></div>
                  <!-- 到着日時差 start-->
                  <ng-container
                    *ngIf="
                      bound.destinationArrivalEstimatedDaysDifference || bound.destinationArrivalDaysDifference === -1;
                      else notBold
                    "
                  >
                    <div
                      class="c-flight-plan__time-box"
                      *ngIf="bound.destinationArrivalEstimatedDaysDifference || bound.destinationArrivalDaysDifference"
                    >
                      <span class="c-flight-plan__time-text" style="color: #d91829; font-weight: bold">{{
                        stringArrivalDaysDifference?.[boundIndex] ?? '' | staticMsg
                      }}</span>
                    </div>
                  </ng-container>
                  <ng-template #notBold>
                    <div
                      class="c-flight-plan__time-box"
                      *ngIf="bound.destinationArrivalEstimatedDaysDifference || bound.destinationArrivalDaysDifference"
                    >
                      <span class="c-flight-plan__time-text">{{
                        stringArrivalDaysDifference?.[boundIndex] ?? '' | staticMsg
                      }}</span>
                    </div>
                  </ng-template>
                  <!-- 到着日時差 end-->
                </ng-template>
                <!-- 時間変更なし end-->
                <!-- 時間変更有無で出し分け（到着時刻） end -->
              </div>
            </div>
          </div>

          <div class="p-flight-container__info">
            <div class="c-flight-detail-overview02">
              <div class="c-flight-detail-overview02__item">
                <p class="c-flight-detail-overview02__item-title">
                  {{ 'm_static_message-label.operate' | staticMsg }}
                </p>
                <span class="c-ana-icon01"
                  ><img
                    *ngIf="bound.isAllNhGroupOperated"
                    class="c-ana-icon01__img"
                    src="assets/images/logo_ana_s.svg"
                    width="54"
                    height="22"
                    alt="{{ 'alt.nhFlight' | staticMsg }}"
                /></span>
                <!-- 運航キャリアリスト名称表示 start -->
                <ng-container *ngIf="!bound.isAllNhGroupOperated && bound.isAllStarAllianceOperated">
                  <div class="c-flight-detail-overview02__item-box">
                    <span class="c-asam-icon01"
                      ><img
                        class="c-asam-icon01__img"
                        src="assets/images/logo_star_alliance_20.svg"
                        width="20"
                        height="20"
                        alt="{{ 'alt.OperatedByStarAllianceGroup' | staticMsg }}"
                      />
                      <span
                        *ngIf="this.operatingAirlineList[boundIndex]"
                        [innerHTML]="
                          'label.sectionOpCarrierWording'
                            | staticMsg
                              : {
                                  '0': this.operatingAirlineList[boundIndex]
                                }
                        "
                      ></span>
                    </span>
                  </div>
                </ng-container>
                <ng-container *ngIf="!bound.isAllNhGroupOperated && !bound.isAllStarAllianceOperated">
                  <div class="c-flight-detail-overview02__item-box">
                    <span class="c-asam-icon01">
                      <span
                        *ngIf="this.operatingAirlineList[boundIndex]"
                        [innerHTML]="
                          'label.sectionOpCarrierWording'
                            | staticMsg
                              : {
                                  '0': this.operatingAirlineList[boundIndex]
                                }
                        "
                      ></span>
                    </span>
                  </div>
                </ng-container>
                <!-- 運航キャリアリスト名称表示 end -->
              </div>
              <div
                *ngIf="!isPc && bound.isContainedSubjectToGovernmentApproval"
                class="c-flight-detail-overview01__item"
              >
                <ul class="c-information-list01">
                  <li class="c-information-list01__item">
                    <p
                      class="c-information-list01"
                      [innerHTML]="'m_static_message-label.pendingGovernmentApproval' | staticMsg"
                    ></p>
                  </li>
                </ul>
              </div>
              <div class="c-flight-detail-overview02__2col">
                <div class="c-flight-detail-overview02__2col-left">
                  <p
                    class="c-flight-detail-overview02__2col-left-title"
                    *ngIf="
                      bound.wiFiType ||
                      (acvList && acvList.length > 0 && acvList[boundIndex] && acvList[boundIndex].length > 0)
                    "
                  >
                    {{ 'm_static_message-label.optionalServices' | staticMsg }}
                  </p>
                  <!-- wifiアイコン表示出し分け start -->
                  <ng-container *ngIf="bound.wiFiType">
                    <ng-container *ngIf="bound.wiFiType === '0'">
                      <div class="c-flight-detail-overview02__2col-left-item">
                        <span class="c-wifi-icon01"
                          ><img
                            class="c-wifi-icon01__img"
                            src="assets/images/icon_wifi_not_available_20.svg"
                            alt="{{ 'm_static_message-alt.wifiNotAvailable' | staticMsg }}"
                            width="20"
                            height="20"
                        /></span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="bound.wiFiType === '1'">
                      <div class="c-flight-detail-overview02__2col-left-item">
                        <span class="c-wifi-icon01"
                          ><img
                            class="c-wifi-icon01__img"
                            src="assets/images/icon_wifi_primary_20.svg"
                            alt="{{ 'm_static_message-alt.wifiAvailable' | staticMsg }}"
                            width="20"
                            height="20"
                        /></span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="bound.wiFiType === '2'">
                      <div class="c-flight-detail-overview02__2col-left-item">
                        <span class="c-wifi-icon01">
                          <asw-tooltip
                            iconImage="<img src=&quot;assets/images/icon_wifi_primary_20.svg&quot; alt=&quot;{{
                              wifiSomeAvailableAlt | staticMsg
                            }}&quot; width=&quot;20&quot; height=&quot;20&quot; />"
                            [tooltipContent]="'m_static_message-tooltip.onlySomeSegments' | staticMsg"
                            [tooltipDisplayType]="'tap'"
                          ></asw-tooltip>
                          <span>{{ 'm_static_message-label.onlySomeSegments' | staticMsg }}</span>
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                  <!-- wifiアイコン表示出し分け end -->
                  <!-- acvList表示 start -->
                  <div *ngFor="let acv of acvList[boundIndex]" class="c-flight-detail-overview02__2col-left-item">
                    <ng-container *ngIf="acv.type === 'tooltip'">
                      <span class="c-ana-couchii-icon01">
                        <asw-tooltip
                          iconImage="{{ acv.img }}"
                          [tooltipContent]="acv.tooltipText"
                          [tooltipDisplayType]="'tap'"
                        ></asw-tooltip>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="acv.type === 'text'">
                      <span class="c-ana-couchii-icon01" [innerHTML]="acv.original | staticMsg"></span>
                    </ng-container>
                  </div>
                  <!-- acvList表示 end -->
                </div>
                <div class="c-flight-detail-overview02__2col-right">
                  <div
                    *ngIf="isPc && bound.isContainedSubjectToGovernmentApproval"
                    class="c-flight-detail-overview01__item"
                    style="padding: 0 0 5px"
                  >
                    <ul class="c-information-list01">
                      <li class="c-information-list01__item">
                        <p
                          class="c-information-list01"
                          [innerHTML]="'m_static_message-label.pendingGovernmentApproval' | staticMsg"
                        ></p>
                      </li>
                    </ul>
                  </div>
                  <a
                    href="#"
                    class="c-text-link-arrow01 c-text-link-arrow01--s"
                    id="complex-flight-availability-flight-details-a"
                    (throttleClick$)="this.flightDetails($event, boundIndex)"
                    aswThrottleClick
                    >{{ 'm_static_message-label.details1' | staticMsg }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="p-flight-container__inner-item2">
          <div class="p-flight-container__fare-applied" *ngIf="fareFamily?.isPromotionApplied">
            <span class="c-promotion-applied"
              ><img
                class="c-promotion-applied__img"
                src="assets/images/icon_promotion_applied_20.svg"
                width="20"
                height="20"
                alt="{{ 'label.promotionApplied' | staticMsg }}"
            /></span>
          </div>
          <div class="p-flight-container__fare p-flight-container__fare--seats">
            <div class="p-flight-container__fare-item p-flight-container__fare-item--2">
              <p
                class="p-flight-container__fare-item"
                *ngIf="fareFamily?.airOffers?.[0]?.complexBounds?.[boundIndex]?.quotaType === 'available'"
              >
                <em>{{ 'm_static_message-label.remainSeat' | staticMsg }}</em>
              </p>
              <p
                class="p-flight-container__fare-item"
                *ngIf="fareFamily?.airOffers?.[0]?.complexBounds?.[boundIndex]?.quotaType === 'few'"
              >
                <em>{{
                  'm_static_message-label.lastSeatWithSpan1'
                    | staticMsg: { '0': fareFamily?.airOffers?.[0]?.complexBounds?.[boundIndex]?.quota }
                }}</em>
              </p>
            </div>
            <div class="p-flight-container__fare-item p-flight-container__fare-item--3">
              <button
                class="c-btn-tertiary c-btn-tertiary--s"
                id="complex-flight-availability-changeByBound-{{ boundIndex }}-tertiary"
                (throttleClick$)="change($event, boundIndex)"
                aswThrottleClick
              >
                <span class="c-btn-tertiary__text" aria-hidden="true">{{
                  'm_static_message-label.showOtherFlight' | staticMsg
                }}</span>
                <span class="u-visually-hidden">{{
                  'reader.showOtherFlight.screenReader' | staticMsg : { '0': boundIndex + 1 }
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 旅程表示 end -->
  </div>
</ng-container>
